import { useState } from "react";
import document from "../../assets/icons/document.svg";

export const ImageWithFallback = ({
  src,
  alt,
  fallback,
  ...props
}: React.JSX.IntrinsicElements["img"] & {
  fallback?: React.JSX.IntrinsicElements["img"]["src"];
}) => {
  const [isFallback, setIsFallback] = useState(false);

  return !isFallback ? (
    <img
      src={src}
      alt={alt}
      {...props}
      onError={(event) => {
        setIsFallback(true);
        props.onError?.(event);
      }}
    />
  ) : (
    <img
      alt={alt ?? "default-fallback-icon"}
      {...props}
      src={fallback ?? document}
    />
  );
};
